import type { Board } from "../board";
import type { Direction } from "../direction";
import { cycleDirection, directionDelta } from "../direction";
import type { Player } from "../player";
import { ShortSolidifierShot } from "../projectiles/shortSolidifierShot";
import { Sound } from "../things/sounds/sound";
import { SoundId } from "../things/sounds/soundId";
import { ParticleType } from "../particleType";
import { Weapon } from "../weapon";

export class TripleSolidifier extends Weapon {
	static key = "TripleSolidifier";
	constructor(owner: Player) {
		super(owner, 0, true);
	}

	override getMuzzleFlashType(): ParticleType {
		return ParticleType.MUZZLE_FLASH_GREEN_WIDE;
	}

	override getMuzzleFlashCount(): number {
		return 12;
	}

	fire(direction: Direction, board: Board): void {
		board.addNonPhysicalThing(new Sound(SoundId.SHOT_SOLIDIFIER));
		for (let cycle = -1; cycle <= 1; cycle++) {
			const spawnDir = cycleDirection(direction, cycle);
			const spawnPos = this.owner.xy.add(directionDelta(spawnDir));
			const shot = new ShortSolidifierShot(spawnPos, direction);
			this.shotProjectile(board, shot);
		}
	}

	static deserialize(data: any, owner: Player): TripleSolidifier {
		const gun = new TripleSolidifier(owner);
		gun.ammo = data.ammo;
		return gun;
	}
}
